var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaskAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7327_41599",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7327_41599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 110C53.0833 110 46.5833 108.687 40.5 106.06C34.4167 103.437 29.125 99.875 24.625 95.375C20.125 90.875 16.5633 85.5833 13.94 79.5C11.3133 73.4167 10 66.9167 10 60C10 53.0833 11.3133 46.5833 13.94 40.5C16.5633 34.4167 20.125 29.125 24.625 24.625C29.125 20.125 34.4167 16.5617 40.5 13.935C46.5833 11.3117 53.0833 10 60 10C65.4167 10 70.5417 10.7917 75.375 12.375C80.2083 13.9583 84.6667 16.1667 88.75 19L81.5 26.375C78.3333 24.375 74.9583 22.8117 71.375 21.685C67.7917 20.5617 64 20 60 20C48.9167 20 39.48 23.895 31.69 31.685C23.8967 39.4783 20 48.9167 20 60C20 71.0833 23.8967 80.5217 31.69 88.315C39.48 96.105 48.9167 100 60 100C71.0833 100 80.5217 96.105 88.315 88.315C96.105 80.5217 100 71.0833 100 60C100 58.5 99.9167 57 99.75 55.5C99.5833 54 99.3333 52.5417 99 51.125L107.125 43C108.042 45.6667 108.75 48.4167 109.25 51.25C109.75 54.0833 110 57 110 60C110 66.9167 108.687 73.4167 106.06 79.5C103.437 85.5833 99.875 90.875 95.375 95.375C90.875 99.875 85.5833 103.437 79.5 106.06C73.4167 108.687 66.9167 110 60 110ZM53 83L31.75 61.75L38.75 54.75L53 69L103 18.875L110 25.875L53 83Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskAlt);
export default __webpack_public_path__ + "static/media/TaskAlt.61b7bafb7c273f9a9c07ba0f8573a091.svg";
export { ForwardRef as ReactComponent };